import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import { Paper, Box, Typography, Divider } from '@mui/material';
import RouteIcon from '@mui/icons-material/Route';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import CancelIcon from '@mui/icons-material/Cancel';
import Active_iocn from "../../images/organization/Active_Icon.svg";
import Inactive_iocn from "../../images/organization/Inactive_Icon.svg";
import config from '../../config.js';
import VehicleImagePlaceholder from "./VehicleImagePlaceholder";

const VehicleDetailsOverlay = ({ vehicle, route, isMoving, stoppedDuration, position }) => {
  if (!position) return null;

  // Find the most recent VehicleImage document
  let vehicleImageDoc = null;
  if (vehicle?.documents) {
    const vehicleImages = vehicle.documents.filter(doc => doc.name === "VehicleImage");
    if (vehicleImages.length > 0) {
      // Sort by createdAt descending and take the most recent
      vehicleImages.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      vehicleImageDoc = vehicleImages[0];
    }
  }

  // Build the image URL as in VehicleAddMain.jsx
  const vehicleImageUrl = vehicleImageDoc
    ? `${config.baseURL}/upload/image?fileName=${encodeURIComponent(vehicleImageDoc.location)}`
    : null;

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return <img src={Active_iocn} alt="Active" />;
      case 'inactive':
      case 'dead':
        return <img src={Inactive_iocn} alt="Inactive" />;
      default:
        return null;
    }
  };
  console.log(vehicle)

  const statusIcon = getStatusIcon(vehicle?.status);

  return (
    <OverlayView
      key={vehicle?.id || vehicle?.device_id || "vehicle-details"}
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Paper
        elevation={3}
        sx={{
          position: 'relative',
          top: '-200px',
          left: '30px',
          width: '320px',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        {/* Header with vehicle name and status */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
          paddingBottom: '8px'
        }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              color: '#183059',
              fontSize: '20px'
            }}
          >
            {vehicle?.name || 'Unknown Vehicle'}
          </Typography>
          <Box
            sx={{
              color: '#fff',
              padding: '4px 16px',
              borderRadius: '16px',
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {statusIcon}
          </Box>
        </Box>

        {/* Vehicle image */}
        <Box sx={{ padding: '0 16px', marginBottom: '8px' }}>
          {vehicleImageUrl ? (
            <img
              src={vehicleImageUrl}
              alt="Vehicle"
              style={{
                width: '100%',
                height: '200px',
                objectFit: 'cover',
                borderRadius: '4px'
              }}
            />
          ) : (
            <VehicleImagePlaceholder width="100%" height={200} />
          )}
        </Box>

        <Divider sx={{ margin: '0 16px' }} />

        {/* Details section */}
        <Box sx={{ padding: '16px' }}>
          {/* Route info */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: '#f0f2f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px'
              }}
            >
              <RouteIcon sx={{ color: '#6b7280', fontSize: '20px' }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontWeight: 500,
                  marginRight: '24px',
                  width: '65px'
                }}
              >
                Route:
              </Typography>
              <Typography sx={{ color: '#374151', fontWeight: 500 }}>
                {route?.name || 'No Route Assigned'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </OverlayView>
  );
};

export default VehicleDetailsOverlay;